import React, { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import EmergencySelector from "@/components/EmergencySelector";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import Coverage from "@/components/Coverage";
import WhyUs from "@/components/WhyUs";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import MobileDialer from "@/components/MobileDialer";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-night p-8 text-center">
          <div>
            <p className="font-display text-2xl font-bold text-white">Qualcosa è andato storto.</p>
            <p className="mt-2 text-slate-400">Ricarica la pagina, oppure chiamaci direttamente.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function SmoothScroll() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const lenis = new Lenis({ lerp: 0.12, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -72 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);
  return null;
}

function Landing() {
  return (
    <div className="relative min-h-screen bg-night pb-[76px] md:pb-0">
      <div className="grain" aria-hidden="true" />
      <SmoothScroll />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <EmergencySelector />
        <Services />
        <HowItWorks />
        <Coverage />
        <WhyUs />
        <FinalCta />
      </main>
      <Footer />
      <MobileDialer />
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Landing />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
